// extracted by mini-css-extract-plugin
export default {"container":"K3OY","actions":"ewGz","btn":"fNUt","blue":"IAfo","red":"rX57","emptyDescription":"rWCG"};